import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { getSingers } from "../http/singerApi";
import { useNavigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../utils/constants";
import { observer } from "mobx-react-lite";
import { Context } from "../index";

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "singer",
    headerName: "Исполнитель",
    width: 150,
    editable: false,
    sortable: true,
  },
];

const Singers = observer(() => {
  const [parse, setParse] = React.useState([]);
  const navigate = useNavigate();
  const { user } = React.useContext(Context);

  React.useEffect(() => {
    const getData = async () => {
      try {
        const parsed = await getSingers();
        console.log(parsed);
        setParse([...parsed]);
      } catch (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          user.setIsAuth(false);
          return navigate(LOGIN_ROUTE);
        }
      }
    };
    getData();
  }, []);

  return (
    <div>
      {/* <div style={{ marginBottom: "2rem", paddingTop: "2rem" }}>
        <SingersAdder />
      </div> */}

      {parse && columns && (
        <Box sx={{ height: "100%", width: "100%" }}>
          <DataGrid
            rows={parse}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 20, 50, 100]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
    </div>
  );
});

export default Singers;
